import React, { Component } from 'react'; 
import * as Constants from './api/constants' 
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Copyright from './copyright.component/copyright'
import SpasList from './spa.components/SpaList';
import { MainContext } from '../context/MainContext'
import { UserContext } from '../context/UserContext'
export default class Users extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      spas: undefined,
      spinner: false,
      spasCount: 0
    };
  }

  clearSpaList = () => {
    this.setState({
      spas: undefined,
      spinner: false,
      spasCount: 0
    });
  }

  getSpasList = (name = '', email = '', macAddress = '', spaName = '', mqtt = false, smartSignal = false, page = 0, sortField = "id", sortDirection = "asc") => {
    const requestOptions = {
      method: 'GET', 
      credentials: "include"
    };
    
    const parameters = new URLSearchParams({
      searchName: name,
      searchEmail: email,
      searchMacAddress: macAddress,
      searchSpaName: spaName,
      mqtt: mqtt, 
      smartSignal: smartSignal,
      // page: page, 
      // pageSize: 10,
      // sortField: sortField, 
      // sortDirection: sortDirection
    });
    fetch(Constants.baseURL + Constants.apiSpasList + '?' + parameters, requestOptions) 
      .then(response => { 
          if (!response.ok && response.status !== 404) {
              this.props.history.push('/');
          }
          return response.json() })
      .then(data => {  
        this.setState({ 
          spas: data.spas,
          spinner: false,
          spasCount: data.spasCount
        });
      }) 
      .catch(error => { console.log('request failed', error); }); 
  }

  componentDidMount() {
    this._isMounted = true;

    this.setState({
      spas: undefined,
      spinner: false,
      spasCount: 0
    })

    this.getSpasList('', '', '', '', false, false, 0);
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.setState = (state,callback)=>{
      return;
    };
  }

  render() {
    return (<Container maxWidth="900px" sx={{ mt: 4, mb: 4 }}>
    <Grid container spacing={3}>
      {/* SpasList */}
      <Grid item xs={12} md={12} lg={12}>
          <Paper
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              bgcolor: 'rgba(255,255,255,0.04)',
              border: '1px solid rgba(255,255,255,0.08)',
            }}
          >
          <UserContext.Provider value={this.props} >
            <MainContext.Provider value={{
                  spas: this.state.spas,
                  spasCount: this.state.spasCount 
              }}>
              <SpasList getSpasList={this.getSpasList} clearSpaList={this.clearSpaList} />
            </MainContext.Provider>
          </UserContext.Provider>
        </Paper>
      </Grid>
    </Grid>
    <Copyright sx={{ pt: 4 }} />
  </Container>);
  }
}